module.exports = __webpack_public_path__ + "static/img/newimg.584d60b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/newimg.png
// module id = SEs6
// module chunks = 37